import React from "react";

//Styles
import "./styles.scss";

//Svg
import AuthBanner from "../../Assets/Images/AuthBanner.png";
import LOGO from "../../Assets/Svg/Auth/Logo.svg";

//Custom components
import FooterColorLine from "Components/FooterColorLine";

const AuthLayout = ({ children }) => {
  return (
    <>
      <div className="auth-layout-root-container">
        <div className="auth-layout-left-container">
          <div
            className="auth-layout-left-container-bg-image"
            style={{
              backgroundImage: `url(${AuthBanner})`,
              backgroundSize: "cover",
            }}
          >
            <div className="auth-layout-black-layer">
              <img src={LOGO} alt="LOGO" />
            </div>
          </div>
        </div>
        <div className="auth-layout-right-container">{children}</div>
      </div>
      <div className="auth-layout-footer">
        <FooterColorLine />
      </div>
    </>
  );
};

export default AuthLayout;
